import { Host } from "@reporting/rp-app-host";
import { css, html } from "lit";
import { customElement } from "lit/decorators.js";
import { ExtensionHost } from "./extensionHost";
import { createRef, ref } from "lit/directives/ref.js";
import { Layout } from '@omegagrid/core';

@customElement('rp-extensionhost-internal')
export class ExtensionInternalHost extends ExtensionHost {

	static styles = [...Host.styles, css`
		.host {
			width: 100%;
			height: 100%;
		}
	`];

	hostElementRef = createRef<HTMLElement>();
	get hostElement() { return this.hostElementRef.value as HTMLElement & Layout }

	reload(mainResourceContent?: string) {
		super.reload(mainResourceContent);
		this.requestUpdate();
	}

	refresh(mainResourceContent?: string) {
		this.engine?.refresh(mainResourceContent);
	}

	async updated() {
		if (!this.container || this.engine) return;
		await this.loadExtension();
	}

	layout() {
		const component = this.hostElement?.firstElementChild as Layout;
		if (component?.layout) component.layout();
	}

	render = () => html`<div class="host" ${ref(this.hostElementRef)}></div>`;

}
